<!-- Loading skeleton -->
<div *ngIf="indicators.loading">
  <ui-skeleton [uiActive]="true" [uiTitle]="false" [uiParagraph]="{ width: '100%', rows: 1 }" [uiSectionHeight]="{ title: 'h-sm', paragraph: 'h-md' }"></ui-skeleton>
  <div class="sp-mb-32" *ngFor="let i of [1, 2, 3]">
    <ui-skeleton [uiSectionHeight]="{ title: 'h-sm', paragraph: 'h-md' }" [uiActive]="true" [uiParagraph]="{ width: '100%', rows: 4 }"></ui-skeleton>
  </div>
</div>

<!-- Search input -->
<div *ngIf="!indicators.loading">
  <ui-input-text-field
    class="sp-mb-24 search"
    [(value)]="filterQuery"
    [debounceTime]="80"
    [placeholder]="'search_by_title_description_or_owner' | localize"
    (valueChange)="filterByName(filterQuery)"
    uiType="search"
    uiTheme="outline"
    updateOn="change"
    data-test-id="objective-selector-search-input"></ui-input-text-field>
</div>

<!-- Initial screen -->
<div *ngIf="selectedScreen === 'sessions'">
  <!-- My OKRs -->
  <div class="sp-mb-32" *ngIf="goalItems.myGoals.length">
    <single-goal-selector-goals-list
      [sectionTitle]="'my_objectives' | localize"
      [goals]="goalItems.myGoals"
      [unselectableId]="unselectableId"
      (goalSelected)="onGoalSelected($event)"></single-goal-selector-goals-list>
  </div>

  <!-- My team OKRs -->
  <div class="sp-mb-32" *ngIf="goalItems.myTeamsGoals.length">
    <single-goal-selector-goals-list
      [sectionTitle]="'my_team_objectives' | localize"
      [goals]="goalItems.myTeamsGoals"
      [unselectableId]="unselectableId"
      (goalSelected)="onGoalSelected($event)"></single-goal-selector-goals-list>
  </div>

  <!-- My parent team OKRs -->
  <div class="sp-mb-32" *ngIf="goalItems.myParentTeamsGoals.length">
    <single-goal-selector-goals-list
      [sectionTitle]="'my_parent_team_objectives' | localize"
      [goals]="goalItems.myParentTeamsGoals"
      [unselectableId]="unselectableId"
      (goalSelected)="onGoalSelected($event)"></single-goal-selector-goals-list>
  </div>

  <!-- Session tree -->
  <div *ngIf="sessionsTree?.children?.length">
    <div class="section-title">{{ "other_okrs" | localize }}</div>
    <div *ngFor="let session of sessionsTree.children; let i = index">
      <div [class.border-top]="i === 0">
        <single-goal-selector-session-tree [session]="session" (sessionSelected)="selectSessionFromList($event)"></single-goal-selector-session-tree>
      </div>
    </div>
  </div>

  <!-- No sessions message -->
  <single-goal-selector-no-items *ngIf="!hasSessions" [message]="'no_active_sessions_and_objectives' | localize"></single-goal-selector-no-items>
</div>

<!-- Session screen -->
<div *ngIf="selectedScreen === 'goals'">
  <!-- Back to sessions button -->
  <button class="sp-mb-2 back-to-sessions" *ngIf="hasSessions" (click)="backToSessions()" ui-button uiType="link" data-test-id="objective-selector-back-to-sessions-button">
    <i ui-icon uiType="chevron-left-big"></i>
    {{ "back_to_sessions" | localize }}
  </button>

  <div *ngIf="selectedSession?.id">
    <single-goal-selector-session-row [session]="selectedSession" [enableOkrSelectionOnly]="enableOkrSelectionOnly" (sessionSelected)="onSessionSelected($event)"></single-goal-selector-session-row>
  </div>

  <div *ngIf="!selectedSession?.id">
    <div *ngFor="let session of sessions | filter : filterQuery | orderBy : 'title'">
      <single-goal-selector-session-row [session]="session" [enableOkrSelectionOnly]="enableOkrSelectionOnly" (sessionSelected)="onSessionSelected($event)"></single-goal-selector-session-row>
    </div>
  </div>

  <!-- Loading goals skeleton -->
  <ui-skeleton *ngIf="indicators.gettingGoals" [uiActive]="true" [uiTitle]="false" [uiParagraph]="{ width: '100%', rows: 4 }" [uiSectionHeight]="{ title: 'h-sm', paragraph: 'h-md' }"></ui-skeleton>

  <div *ngIf="!indicators.gettingGoals">
    <!-- No goals message -->
    <single-goal-selector-no-items *ngIf="!goals.children?.length" [message]="'no_objectives_found' | localize"></single-goal-selector-no-items>

    <!-- Objectives tree -->
    <div *ngFor="let childGoal of goals.children">
      <single-goal-selector-goal-tree [goalNode]="childGoal" [unselectableId]="unselectableId" [hidePrivate]="true"></single-goal-selector-goal-tree>
    </div>
  </div>
</div>

<ng-container *uiModalFooter></ng-container>
